import { render, staticRenderFns } from "./AnaliseRecebimento.vue?vue&type=template&id=6ca56dcc&"
import script from "./AnaliseRecebimento.vue?vue&type=script&lang=js&"
export * from "./AnaliseRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports